<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('detailDispositif.infoTech.title.info') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.planRecollement')"
                   custom-class="has-text-link">
            <p class="has-text-default">{{ dispositifTechnique.planRecollement }}</p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.particularite')"
                   custom-class="has-text-link">
            <p class="has-text-default">{{ dispositifTechnique.particularite }}</p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.distanceEnMCablesEdf')"
                   custom-class="has-text-link">
            <p class="has-text-default">{{ dispositifTechnique.distanceEnMCablesEdf }}</p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.cableEdfProx')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.cableEdfProx ? $t('general.oui') : $t('general.non') }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.fournisseur')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.fournisseurElectricite ?
              dispositifTechnique.fournisseurElectricite.nomCommercial : null }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.proprietaire')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.tiersProprietaire ?
              dispositifTechnique.tiersProprietaire.nomCommercial : null }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.hauteurSousPanneau')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.hauteurSousPanneau }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.nacelleNecessaire')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.nacelleNecessaire ? $t('general.oui') : $t('general.non') }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.grueNecessaire')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.grueNecessaire ? $t('general.oui') : $t('general.non') }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.echelleNecessaire')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.echelleNecessaire ? $t('general.oui') : $t('general.non') }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.autreEquipementNecessaire')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.autreEquipementNecessaire }}
            </p>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailDispositif.infoTech.obstacle')"
                   custom-class="has-text-link">
            <p class="has-text-default">
              {{ dispositifTechnique.obstacle }}
            </p>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('detailDispositif.infoTech.title.accessoire') }}
        </p>
      </header>
      <div class="card-content">
        <b-table :data="dispositifAccessoires" :bordered="true" :striped="true"
                 class="column is-6 pdt-0">
          <template #empty>
            {{ $t('general.autocomplete.noRslt')}}
          </template>
          <b-table-column
            header-class="has-text-default"
            field="libelle"
            v-slot="props"
            :label="$t('detailDispositif.infoTech.accessoire.libelle')">
            {{ getLibelleAccessoire(props.row.accessoireId) }}
          </b-table-column>
          <b-table-column
            header-class="has-text-default"
            field="fournisseur"
            v-slot="props"
            :label="$t('detailDispositif.infoTech.accessoire.fournisseur')">
            {{ getLibelleAccessoireFourniseur(props.row.accessoireId) }}
          </b-table-column>
          <b-table-column
            header-class="has-text-default"
            field="quantite"
            v-slot="props"
            :label="$t('detailDispositif.infoTech.accessoire.quantite')">
            {{ props.row.quantite }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
    dispositifTechnique: {
      type: Object,
      required: true,
    },
    dispositifAccessoires: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    accessoires() {
      return this.parametre(PARAMETRES_KEYS.accessoire);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLibelleAccessoire(accessoireId) {
      const accessoireFind = this.accessoires.find((acc) => {
        return acc.id === accessoireId;
      });
      return accessoireFind?.libelle ?? null;
    },
    getLibelleAccessoireFourniseur(accessoireId) {
      const accessoireFind = this.accessoires.find((acc) => {
        return acc.id === accessoireId;
      });
      return accessoireFind?.fournisseur?.nomCommercial ?? null;
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.accessoire]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
